import { render, staticRenderFns } from "./charts3.vue?vue&type=template&id=65d4444a&"
import script from "./charts3.vue?vue&type=script&lang=js&"
export * from "./charts3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports